import AppsResources from './resources';
import transformToCamelCase from '../shared/transformers/toCamelCaseTransformer';
import transformError from '../shared/transformers/errorTransformer';

function get(packageName) {
  return AppsResources.get({ packageName })
    .then(({ body: { app = {} } }) => transformToCamelCase(app))
    .catch(transformError);
}

function getList() {
  return AppsResources.get()
    .then(({ body: { apps = [] } }) => apps.map(transformToCamelCase))
    .catch(transformError);
}

function requestEsraRating(packageName) {
  return AppsResources.requestEsraRating({ packageName }, {})
    .then(({ body = {} }) => transformToCamelCase(body))
    .catch(transformError);
}

function getPurchasesCsvByMonth({ packageName, date, calendarType }) {
  return AppsResources.getPurchasesCsvByMonth({
    packageName,
    date,
    calendar_type: calendarType,
  })
    .then(({ body }) => body)
    .catch(transformError);
}

function getRefundedPurchasesCsvByMonth({ packageName, date, calendarType }) {
  return AppsResources.getRefundedPurchasesCsvByMonth({
    packageName,
    date,
    calendar_type: calendarType,
  })
    .then(({ body }) => body)
    .catch(transformError);
}

function getSubscriptionPurchasesCsvByMonth({
  packageName,
  date,
  calendarType,
}) {
  return AppsResources.getSubscriptionPurchasesCsvByMonth({
    packageName,
    date,
    calendar_type: calendarType,
  })
    .then(({ body }) => body)
    .catch(transformError);
}

function setShowPublishRules({ packageName, showPublishRules }) {
  return AppsResources.modifyPublishRules(
    {
      packageName,
    },
    {
      showPublishRules,
    },
  )
    .then(({ body }) => body)
    .catch(transformError);
}

export default {
  ...AppsResources,
  get,
  getList,
  requestEsraRating,
  getPurchasesCsvByMonth,
  getRefundedPurchasesCsvByMonth,
  getSubscriptionPurchasesCsvByMonth,
  setShowPublishRules,
};
